<template>
  <div class="wrapper">
    <div class="doc-login__header">
      <a href="/" class="doc-login__header__title"
        ><img
          src="/mc/assets/img/login/logo.png"
          alt="logo"
          class="doc-login__header__title__icon"/><img
          src="/mc/assets/img/login/logo-title-text.png"
          alt="logo__text"
          class="doc-login__header__title__text"
      /></a>
    </div>

    <div
      class="main"
      style="padding-top: 0px;min-height: calc(100vh - 5.7rem - 4.8rem);"
    >
      <section class="main-section">
        <h3 class="section-title green-left-head">メールアドレス登録 完了</h3>

        <div class="faq-wrapper">
          <span class="caution" style="color:#000;"
            >メールアドレスの登録が完了しました。</span
          >
          <br /><br />
        </div>

        <!-- <span class="backLink">
          <router-link :to="{
            name: 'logout',
          }" style="display: block; color: #000562; text-decoration: underline">
            →ログインページへ</router-link></span> -->
        <div class="c-passwordReminder__buttonWrap">
          <a
            href="javascript:void(0);"
            @click="onTop"
            class="c-passwordReminder__button"
            >戻る</a
          >
        </div>
      </section>
    </div>
    <!--/.main-->

    <footer class="doc-footer" style="margin-top:0;">
      <nav>
        <ul class="doc-footer__nav">
          <li>
            <a href="/mc/docs/kiyaku.html" target="_blank"
              >プライバシーポリシー</a
            >
          </li>
          <li><a href="/mc/docs/faq.html"> よくある質問 </a></li>
        </ul>
      </nav>
      <p class="doc-footer__copyrights">
        © Hoosiers Holdings Co., Ltd. ALL RIGHTS RESERVED.
      </p>
    </footer>
    <!--/.ftr-->
  </div>
</template>

<script>
import UserService from "../services/user.service";
import store from "../store";
// const REGISTER_DAIBUNRUI_LIST = ["cat001", "cat002"]; // ユーザ登録できる大分類
export default {
  name: "verifyMail",
  data() {
    return {
      canRegistUser: false,
      user_id: null,
    };
  },
  mounted: async function() {
    await this.$nextTick();
    store.dispatch("auth/logout");
    console.log("++++ mounded");
    const email = this.$route.query.email.replace(/ /g, "+");
    const key = this.$route.query.key;
    console.log(email);
    console.log(key);
    try {
      const result = await UserService.verifyEmail(email, key);
      console.log({ result });
      if (result.status != "200") {
        this.$router.push({
          name: "notfound404",
        });
      } else {
        const dai_bunrui = this._.get(result, "data.mansion.dai_bunrui");
        console.log({ dai_bunrui });
        const mansionStatus = this._.get(result, "data.status");
        console.log({ mansionStatus });
        // this.canRegistUser =
        //   REGISTER_DAIBUNRUI_LIST.indexOf(dai_bunrui) >= 0 &&
        //   mansionStatus == "resident"; // 入居者のみ表示
        // console.log("this.canRegistUser", this.canRegistUser);
        this.user_id = this._.get(result, "data._id");
        console.log({ user_id: this.user_id });
      }
    } catch (error) {
      console.log(error);
      this.$router.push({
        name: "notfound404",
      });
    }
  },
  methods: {
    onTop() {
      const email = this.$route.query.email.replace(/ /g, "+");
      if (this.currentUser) {
        this.currentUser.email = email;
      }
      this.$router.push({
        name: "top",
        params: { mc_code: this.mcCode },
      });
    },
    onRegistration() {
      this.$router.push({
        name: "user-registration",
        params: { user_id: this.user_id },
      });
    },
  },
};
</script>

<style>
/* @import "/mc/docs/css/layout.css"; */
.display_none {
  display: none;
}
</style>
